// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1AnmV","label":"Radio_label__qdNcg","checkMark":"Radio_checkMark__2RseL","disabled":"Radio_disabled__1tHtz"};